import { createContext, useContext, useState } from "react";
import { ChatBot } from "@/components/ChatBot";

const ChatContext = createContext(null);

export function ChatProvider({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <ChatContext.Provider value={{ open, openChat: () => setOpen(true), closeChat: () => setOpen(false) }}>
      {children}
      <ChatBot open={open} onClose={() => setOpen(false)} />
    </ChatContext.Provider>
  );
}

export const useChat = () => useContext(ChatContext);
